// extracted by mini-css-extract-plugin
export default {"about":"AboutMe_about__0YgsZ","image":"AboutMe_image__JcZ6t","text":"AboutMe_text__WByfB","arrowRow":"AboutMe_arrowRow__h6Bs9","arrow":"AboutMe_arrow__mShnn"};